<template>
    <transition name="slide-up">
        <div :class="['university', minified ? 'is-minified' : '']" v-show="show">
            <div v-if="minified" @click="expand">{{ $t('university.minified') }}</div>
            <div v-else>
                <h3 v-html="headline"></h3>
                <div class="actions">
                    <!-- put some links here -->    
                </div>
                <input type="text" v-model="search" :placeholder="$t('text.search')" v-if="!onboarding" />
                <action icon="cancel" color="transparent" @click.native="show = false" />
                <div class="lessons" v-if="loaded">
                    <div :class="['lesson', lesson.viewed ? 'is-viewed' : '']" v-for="lesson in filtered" @click="learn(lesson)">
                        <!-- <em v-if="lesson.tag">{{ lesson.tag }}</em> -->
                        <!-- <i>{{ lesson.duration }}</i> -->
                        <icon name="check" class="status" v-if="lesson.viewed" />
                        <span>{{ lesson.name }}</span>
                    </div>
                    <div v-if=" ! filtered.length">
                        {{ $t('university.no_lessons') }}
                        <a href="#" @click.prevent="showAll()">{{ $t('university.show_all') }}</a>
                    </div>
                </div>
                <div class="lessons" v-else>
                    <div>
                        {{ $t('text.loading') }}
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import events from '../../events/events';

export default
{
    name: 'University',

    data()
    {
        return {
            show: false,
            loaded: false,
            search: '',
            all: false,
            lessons: [],
            minified: false,
        }
    },

    computed:
    {
        demo()
        {
            return this.$store.state.current.account.demo;
        },

        onboarding()
        {
            return this.$store.state.current.membership.onboarding;
        },

        headline()
        {
            if (this.onboarding) return this.$t('university.lets_begin');
            
            return this.$t('university.headline');
        },

        filtered()
        {
            // reject, if...
            let lessons = _.reject(this.lessons, lesson =>
            {
                if ( ! this.search && this.all) return false;

                // is this a lesson for the demo?
                let demo = inArray('demo', lesson.flags);

                // ... demo is active, but lesson is not for demo (or vice versa)
                if (this.demo && ! demo) return true;
                if ( ! this.demo && demo) return true;

                // ...search term does not match
                if (this.search && ! lesson.name.match(new RegExp(this.search, 'i')))
                {
                    return true;
                }

                // PAGE
                // ...lesson has page constraints and does not match page context (search is global, though!)
                if ( ! this.search && lesson.pages.length && ! inArray(this.$route.name, lesson.pages))
                {
                    return true;
                }

                // ROLE
                // ...lesson has role constraints and does not match role context
                if (lesson.roles.length && ! this.$onduro.hasRole(lesson.roles))
                {
                    return true;
                }

                // MODULE
                // ...lesson has module constraints and does not match module context
                if (lesson.modules.length && ! this.$onduro.hasModule(lesson.modules))
                {
                    return true;
                }

                // CONFIG
                // ...lesson has config constraints and does not match config context
                if (lesson.configs.length)
                {
                    let count = 0;
                    _.forEach(lesson.configs, config =>
                    {
                        if (this.$onduro.getConfig(config)) count++;
                    });

                    if (lesson.configs.length != count) return true;
                }

                return false;
            });

            // order by priority
            lessons = _.orderBy(lessons, 'priority', 'desc');

            return lessons;
        },
    },

    created()
    {
        events.$listen('university.open', () =>
        {
            this.open();
        });

        events.$listen('university.close', () =>
        {
            this.close();
        });

        events.$listen('university.toggle', () =>
        {
            this.show ? this.close() : this.open();
        });

        events.$listen('university.minify', () =>
        {
            this.minified = true;
        });
    },

    destroyed()
    {
        // events do not have to be turned off anymore,
        // since we are using the "$listen" method on 
        // the events bus

        // events.$off('university.open');
        // events.$off('university.close');
        // events.$off('university.toggle');

        window.removeEventListener('keyup', this.closeEsc, false);
    },

    watch:
    {
        '$route.name'(val)
        {
            this.all = false;
        }
    },

    methods:
    {
        open()
        {
            this.all = false;
            this.show = true;
            this.loaded = false;

            this.$http.get('/api/lessons')
            .then(response =>
            {
                this.lessons = response.data;
                this.$university.lessons = response.data;

                this.$nextTick(() => 
                {
                    events.$emit('university.loaded', this.filtered[0]);
                });

                this.loaded = true;
            });

            window.addEventListener('keyup', this.closeEsc, false);
        },

        expand()
        {
            this.minified = false;

            events.$emit('university.expand');
        },

        close()
        {
            this.search = '';
            this.show = false;

            window.removeEventListener('keyup', this.closeEsc, false);
        },

        showAll()
        {
            this.search = '';
            this.all = true;
        },

        learn(lesson)
        {
            this.$university.lesson(lesson);
        },

        closeEsc(e) 
        {
            if (e.keyCode === 27) 
            {
                if (this.search) 
                {
                    this.search = '';
                    return;
                }

                this.close();
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// University.vue?2fb23291